<template lang="pug">
div
    grid-table-component(
        :headers='headers',
        :data='paginacao.processos',
        :is-paginated='true',
        :is-loading='isLoading',
        :pagination='setPagination()',
        @table:page-changed='checkPaginationChange($event)'
    )
        template(v-slot:processoSelecionado='{ item }')
            checkbox-input-component(v-model='item') 

        template(v-slot:codigoImovel='{ item }')
            span(v-tooltip='{ label: item.codigoImovel, position: "bottom", minWidth: "360px" }') {{ item.codigoImovel | ellipsis(6, 4) }}

        template(v-slot:copiarCodigoImovel='{ item }')
            span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
                button-component.copy-button(
                                label='',
                                icon='mdi-content-copy',
                                color='green',
                                @click.native='copyClipboard(item)'
                            )

        template(v-slot:areaTotalCompensar='{ item }')
            span {{ item.areaTotalCompensar | decimal }}

        template(v-slot:areaTotalRecompor='{ item }')
            span {{ item.areaTotalRecompor | decimal }}

        template(v-slot:dataEnvioProposta='{ item }')
            span {{ item.dataEnvioProposta | data }}

        template(v-slot:dataVinculoTecnico='{ item }')
            span {{ getTecnicoProcessoInfo(item).dataVinculacao | data }}

        template(v-slot:condicaoInscricao='{ item }')
            span {{ getCondicaoInscricaoLabel(item.condicaoInscricao) }}

        template(v-slot:tecnicosProcesso='{ item }')
            span {{ formatarDataVinculacao(item.tecnicosProcesso) }}

        template(v-slot:condicao='{ item }')
            .actions-check
                chip-component(
                    v-if='getConditionLabel(item.condicao).tooltip',
                    :label='getConditionLabel(item.condicao).label',
                    :background-color='getConditionLabel(item.condicao).chipColor',
                    v-tooltip='{ label: getConditionLabel(item.condicao).tooltip, position: "bottom" }',
                    width='150px'
                )
                chip-component(
                    v-else,
                    :label='getConditionLabel(item.condicao).label',
                    :background-color='getConditionLabel(item.condicao).chipColor',
                    width='150px'
                )

        template(v-slot:acao='{ item }')
            .actions-check
                dropdown-component(
                    :list='montarAcoes(item.acoes)',
                    @input='onAction($event, item)',
                    :props='{ label: "nome" }',
                    :is-select='false',
                    position='left'
                )
    modal-component(
        v-if='modalDesvinculacaoTecnico',
        title='Desvinculação de Técnico para Análise',
        @close='cancelarModalDesvinc'
    )
        ModalDesvinculacaoTecnicoComponent(:processos='processosSelecionados', :tecnicos='tecnicos', @cancelar='cancelarModalDesvinc()', @atualizarGrid='pesquisar()')

    modal-component(
        v-if='modalVinculacaoTecnico',
        title='Vinculação de Técnico para Análise',
        @close='cancelarModalVinc'
    )
        ModalVinculacaoTecnicoComponent(:processos='processosSelecionados', @cancelar='cancelarModalVinc()', @atualizarGrid='pesquisar()')

    .linha.justify-end
            button-component(
                v-if='mostrarFaseProcesso',
                label='Desvincular', 
                icon='mdi-magnify', 
                :tecnicos='tecnicos',
                @click.native='desvincularProcessosCheck', 
                :disabled='!possuiProcessoSelecionado'
            )

</template>

<script>
import { buscarUrlAcessoFichaImovel } from "@/services/ficha-imovel.service";
import { iniciarAnalise } from "@/services/processo.service";
import ModalVinculacaoTecnicoComponent from "@/views/caixaEntrada/components/ModalVinculacaoTecnicoComponent.vue";
import ModalDesvinculacaoTecnicoComponent from "@/views/analiseVinculo/components/ModalDesvinculacaoTecnicoComponent.vue";
import AssinaturaTermoCompromisso from "@/views/assinatura/AssinaturaTermoCompromisso.vue";
import ModalDocumentosAnalise from "@/views/caixaEntrada/components/ModalDocumentosAnalise.vue";
import {
  AcaoEnum,
  CondicaoEnum,
  CondicaoInscricaoEnum,
} from "@/enums/processo.enum.js";
import { consultarProcessos } from "@/utils/breadcrumb.utils";

export default {
  name: "AnaliseVinculoTableComponent",

  components: {
    AssinaturaTermoCompromisso,
    ModalDesvinculacaoTecnicoComponent,
    ModalVinculacaoTecnicoComponent,
    ModalDocumentosAnalise,
  },

  props: {
    headers: {
      type: Array,
      default: null,
    },

    data: {
      type: Array,
      default: null,
    },

    paginacao: {
      type: Object,
      default: () => ({
        total: 0,
        pagina: 1,
        numeroPaginas: 0,
        quantidadePagina: 10,
        processos: [],
      }),
    },

    mostrarFaseProcesso: {
      type: Boolean,
      default: false,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalVinculacaoTecnico: false,
      modalDesvinculacaoTecnico: false,
      modalConfirmacao: false,
      modalAssinaturas: false,
      modalDocumentosAnalise: false,
      processos: [],
      infoProcesso: null,
      tecnicos: [],
    };
  },
  methods: {
    formatarDataVinculacao(tecnicos) {
      if (
        !tecnicos ||
        tecnicos.length === 0 ||
        !tecnicos[0] ||
        tecnicos[0].length === 0
      ) {
        return "Nenhum técnico vinculado";
      }

      const primeiroTecnico = tecnicos[0][0];
      const data = new Date(primeiroTecnico.dataVinculacao);

      return data.toLocaleDateString("pt-BR");
    },

    async onAction(event, processo) {
      this.processo = processo;
      switch (event.id) {
        case AcaoEnum.VISUALIZAR_FICHA_IMOVEL.id:
          buscarUrlAcessoFichaImovel(processo.id).then((response) => {
            window.open(response, "_blank");
          });
          break;
        case AcaoEnum.VINCULAR_TECNICO.id:
          this.modalVinculacaoTecnico = true;
          break;
        case AcaoEnum.DESVINCULAR_TECNICO.id:
          this.desvincularProcessos(processo);
          break;
        case AcaoEnum.ANALISAR.id:
          if (
            this.processo.condicao === CondicaoEnum.EM_ANALISE.id ||
            this.processo.condicao === CondicaoEnum.EM_REANALISE.id
          ) {
            this.irParaAnalise();
            return;
          }
          this.modalConfirmacao = true;
          break;
        case AcaoEnum.VISUALIZAR_TERMO_COMPROMISSO.id:
          this.modalAssinaturas = true;
          break;
        case AcaoEnum.VALIDAR.id:
        case AcaoEnum.VISUALIZAR_ANALISE.id:
          this.irParaAnalise();
          break;
        case AcaoEnum.VISUALIZAR_DOCUMENTOS.id:
          this.infoProcesso = {
            id: processo.id,
            condicao: processo.condicao,
            codigoImovel: processo.codigoImovel,
          };
          this.modalDocumentosAnalise = true;
          break;
        case AcaoEnum.DOWNLOAD_TERMO_COMPROMISSO.id:
          try {
            const response = await buscarInformacoesAnalise(processo.id);

            if (response != null) {
              await downloadDocumento(
                response.caminhoTermoCompromisso,
                "Termo_de_compromisso.pdf"
              );
            } else {
              this.$toast({
                showClose: true,
                message: "Erro ao fazer o download do Termo de Compromisso.",
                type: type,
              });
            }
          } catch (error) {
            this.$toast({
              showClose: true,
              message:
                "Ocorreu um erro ao buscar informações da análise" +
                error.message,
              type: type,
            });
          }
          break;
        case AcaoEnum.VISUALIZAR_ANALISE_HISTORICO.id:
          this.modalDocumentosAnalise = true;
          this.$router.push({
            name: "analise-historico",
            params: { idProcesso: processo.id },
          });
          break;
        default:
          break;
      }
    },

    async downloadDocumento(path, name) {
      const documento = await downloadDocumento(path);
      var file = window.URL.createObjectURL(new Blob([documento.data]));
      var docUrl = document.createElement("a");
      docUrl.href = file;
      docUrl.setAttribute("download", name);
      document.body.appendChild(docUrl);
      docUrl.click();
    },

    checkPaginationChange({ page }) {
      this.$emit("inbox:page-change", page);
    },

    setPagination() {
      return {
        page: this.paginacao.pagina,
        totalPages: this.paginacao.numeroPaginas,
        itemsPerPage: this.paginacao.quantidadePagina,
        totalItems: this.paginacao.total,
        order: "ASC",
      };
    },

    getConditionLabel(condicao) {
      const condicaoEnum = CondicaoEnum[condicao] || {};
      return {
        label: condicaoEnum.label,
        tooltip: condicaoEnum.nome,
        chipColor: condicaoEnum.color,
      };
    },

    getCondicaoInscricaoLabel(idCondicaoInscricao) {
      const condicaoInscricao = Object.values(CondicaoInscricaoEnum).find(
        (item) => item.id === idCondicaoInscricao
      );
      return condicaoInscricao ? condicaoInscricao.label : "Desconhecido";
    },

    async iniciarAnaliseProposta() {
      await iniciarAnalise(this.processo.id);
      this.irParaAnalise();
    },

    irParaAnalise() {
      this.$router.push({
        name: "analise",
        params: { id: this.processo.id },
      });
    },

    montarAcoes(acoes) {
      function compare(a, b) {
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;
        return 0;
      }

      if (this.$route.meta.titulo === consultarProcessos[1].label) {
        return acoes
          .filter(
            (acao) =>
              ![
                AcaoEnum.VALIDAR.id,
                AcaoEnum.ANALISAR.id,
                AcaoEnum.VINCULAR_TECNICO.id,
                AcaoEnum.DESVINCULAR_TECNICO.id,
                AcaoEnum.VISUALIZAR_TERMO_COMPROMISSO.id,
                AcaoEnum.DOWNLOAD_TERMO_COMPROMISSO.id,
              ].includes(acao)
          )
          .map((acao) => AcaoEnum[acao])
          .sort(compare);
      } else {
        return acoes.map((acao) => AcaoEnum[acao]);
      }
    },

    cancelarModalTC() {
      this.modalAssinaturas = false;
    },

    cancelarModalVinc() {
      this.modalVinculacaoTecnico = false;
    },

    cancelarModalDesvinc() {
      this.modalDesvinculacaoTecnico = false;
    },

    pesquisar() {
      this.checkPaginationChange({ page: this.paginacao.pagina });
    },

    copyClipboard(item) {
      navigator.clipboard.writeText(item.codigoImovel);
      this.$toast({
        showClose: true,
        message: "Código Copiado",
        type: "success",
      });
    },
    desvincularProcessos(processo = null) {
      let tecnicosVinculados = [];

      if (processo) {
        // Se um processo específico for passado, pega os técnicos desse processo
        tecnicosVinculados = processo.tecnicosProcesso
          ? processo.tecnicosProcesso.flat()
          : [];
        this.processos = [processo]; // Define o processo atual como um array com o processo passado
      }

      this.modalDesvinculacaoTecnico = true;

      this.tecnicos = tecnicosVinculados.map((tecnico) => ({
        id: tecnico.id,
        nome: tecnico.nm_pessoa,
      }));
    },

    desvincularProcessosCheck() {
      const tecnicosVinculados = this.processosSelecionados.flatMap(
        (processo) =>
          processo.tecnicosProcesso ? processo.tecnicosProcesso.flat() : []
      );

      this.processos = [...this.processosSelecionados];
      this.modalDesvinculacaoTecnico = true;

      this.tecnicos = tecnicosVinculados.map((tecnico) => ({
        id: tecnico.id,
        nome: tecnico.nm_pessoa,
      }));
    },

    getTecnicoProcessoInfo(processo) {
      if (processo.tecnicosProcesso && processo.tecnicosProcesso.length > 0) {
        const tecnico =
          processo.tecnicosProcesso.find(
            (t) => t.id_usuario_tecnico === this.$eu().id
          ) || processo.tecnicosProcesso[0];
        return {
          despacho: tecnico.despacho || "",
          dataVinculacao: tecnico.data_vinculacao || "",
        };
      }
      return { despacho: "", dataVinculacao: "" };
    },
  },
  computed: {
    possuiProcessoSelecionado() {
      return this.data.some((processo) => processo.selecionado);
    },

    processosSelecionados() {
      if (this.processo) {
        this.processos = [];
        this.data.forEach((processo) => {
          processo.selecionado = false;
        });
        this.processos.push(this.processo);
        return this.processos;
      }
      return this.data.filter((processo) => processo.selecionado);
    },
  },
};
</script>
<style lang="scss" scoped>
.copy-button {
  background-color: transparent !important;
  box-shadow: none !important;
}

.modal-tecnico {
  color: var(--primary-black);
}

.subtitle-modal-tecnico {
  font-weight: 600;
  margin-bottom: 15px;
}

.processo {
  margin: 5px 0px 20px 0px;
}

.modal-tecnico .--loading {
  background-color: var(--primary-smoke);
  background-image: url("../../../assets/loading.gif");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50px 50px;
  content: "";
}

.input-despacho {
  margin: 15px 0px;
}
</style>
